import { render, staticRenderFns } from "./AvailableServiceDisplay.vue?vue&type=template&id=35521389&scoped=true"
import script from "./AvailableServiceDisplay.vue?vue&type=script&lang=ts"
export * from "./AvailableServiceDisplay.vue?vue&type=script&lang=ts"
import style0 from "./AvailableServiceDisplay.vue?vue&type=style&index=0&id=35521389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35521389",
  null
  
)

export default component.exports